import InvoiceProtectedLayout from './InvoiceProtectedLayout'

export default InvoiceProtectedLayout
